import React, { Component } from "react";
import Cta from "../cta/cta";
import "./success-card.scss";
import Router from "next/router";
import { LOCAL_TOGGLE_PREMIUM_COFOUNDER } from "../../apollo-state/graphql/mutations";
import { Mutation } from "react-apollo";

class SuccessCard extends Component {
  render() {
    return (
      <div className="succuess-card">
        <h3>Now What?</h3>
        <ul>
          <li>
            <img src="/static/checkout-tag.svg" alt="checkout-tag" />
            <span>
              Check out the Find a{" "}
              <b
                onClick={() => {
                  Router.push("/find-a-co-founder");
                }}
              >
                Co-Founder tab.
              </b>{" "}
              Peruse the users. Do some searching and filtering.
            </span>
          </li>
          <li>
            <img src="/static/checkout-tag.svg" alt="checkout-tag" />
            <span>
              Premium?
              <br /> Use your unlimited messaging to reach out.{" "}
              {/* <b onClick={togglePremiumCofounder}>(Upgrade now)</b> */}
              <Mutation
                mutation={LOCAL_TOGGLE_PREMIUM_COFOUNDER}
                variables={{ message: null }}
              >
                {(togglePremiumCofounder) => (
                  <b onClick={togglePremiumCofounder}>(Upgrade now)</b>
                )}
              </Mutation>
            </span>
          </li>
          <li>
            <img src="/static/checkout-tag.svg" alt="checkout-tag" />
            <span>
              Free Plan?
              <br />
              Remember to come back each day to use your free new conversation.
            </span>
          </li>
          <li>
            <img src="/static/checkout-tag.svg" alt="checkout-tag" />
            <span>
              Guide:
              <br />
              <div className="link-button-section">
                <Cta
                  tag="link"
                  // isExternalLink
                  link="/blog/post/how-to-interview-a-co-founder"
                  text="How to Interview a Co-Founder"
                />
                <Cta
                  tag="link"
                  // isExternalLink
                  link="/blog/post/how-to-build-a-strong-business-partnership"
                  text="How to Build a Strong Business Partnership"
                />
                <Cta
                  tag="link"
                  // isExternalLink
                  link="/blog/post/five-ways-to-find-an-effective-business-partner"
                  text="Five Ways to Find an Effective Business Partner"
                />
                <Cta
                  tag="link"
                  // isExternalLink
                  link="/blog/post/how-to-find-a-cto-for-a-startup"
                  text="How to Find a CTO for a Startup"
                />
              </div>
            </span>
          </li>
        </ul>
        <p>
          *Don’t forget to check your email (and spam folder) to see if you have
          notifications or messages waiting.
        </p>
      </div>
    );
  }
}

export default SuccessCard;
